import React from 'react';

import * as S from './styles';

import { BannerApp } from '../../micros/BannerApp';

import { SectionBannerAppProps } from './types';

const SectionBannerApp = (props: SectionBannerAppProps) => {
	return (
		<S.SectionWrapper
			data-testid="section-banner-app"
			marginBottom={props.marginBottom}
		>
			<BannerApp {...props} />
		</S.SectionWrapper>
	);
};

export default SectionBannerApp;
